import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import GppGoodIcon from "@mui/icons-material/GppGood";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PsychologyIcon from "@mui/icons-material/Psychology";
import RouteIcon from "@mui/icons-material/Route";
import VerifiedIcon from "@mui/icons-material/Verified";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Typography,
  Stack,
} from "@mui/material";
import React from "react";
import { isMobile, isDesktop } from "react-device-detect";
import TaskIcon from "@mui/icons-material/Task";
import ContactForm from "../components/ContactForm";
import FormularioBomberos from "../components/FormularioBomberos";
import DescriptionIcon from "@mui/icons-material/Description";
import { info } from "../helpers/Info";
import "../styles/Habilitaciones.css";
import WhatsAppButton from "../components/WhatsAppButton";
import fondo from "../assets/tuberias.jpg";
import fondo2 from "../assets/tuberias.jpg";
import Reviews from "../components/Reviews";
import FormularioHidraulica from "../components/FormularioHidraulica";

const Hidraulica = () => {
  /*   const ENDPOINT ="https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJHezobOCBn5URqKiywMM8Ht4&fields=reviews,rating&key=AIzaSyCM_BpfwovYkq2p3eWPB2mFlaZE-RpwEuM";*/

  //--------DIRECTO A API
  //  const ENDPOINT = "https://maps.googleapis.com/maps/api/place/details/json?place_id=ChIJHezobOCBn5URqKiywMM8Ht4&fields=rating,user_ratings_total,reviews&language=es&reviews_sort=newest&key=AIzaSyCM_BpfwovYkq2p3eWPB2mFlaZE-RpwEuM"

  //---------LAMBDA
  const ENDPOINT =
    "https://clbzbq5kde.execute-api.sa-east-1.amazonaws.com/prod/api/reviews";

  const PLACE_ID = process.env.REACT_APP_PLACE_ID || "";
  return (
    <Box
      className="habilitaciones"
      sx={{ paddingTop: isMobile ? "70.4px" : "86px", bgcolor: "#fff" }}
    >
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          backgroundImage: !isMobile ? `url(${fondo})` : `url(${fondo2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: !isDesktop ? "column" : "row",
          alignItems: "center",
          color: "white",
          justifyContent: "center",
          textAlign: "center",

          maxWidth: "100%",
          height: !isDesktop ? "50vh" : "calc(100vh - 86px) ",
          maxHeight: "100vh",
          zIndex: 10,
        }}
      >
        <Stack direction="row" justifyContent="center">
          <Box
            sx={{
              zIndex: 10,
              textAlign: "center",
              width: !isDesktop ? "100%" : "40%",
              display: "flex",
              flexDirection: "column",
              justifyContent: isDesktop ? "space-between" : "center",
              /*  height: "100%", */
              maxWidth: "700px",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                maxWidth: isDesktop ? "94%" : isMobile ? "96%" : "90%",
                fontWeight: 700,
                textAlign: "center",
                lineHeight: isDesktop ? "3.3rem" : "",
                fontSize: isDesktop ? "3rem" : "1.5rem !important",
              }}
            >
              solucionamos el sistema hidráulico de tu proyecto
            </Typography>
            <Typography
              variant="body-1"
              sx={{
                maxWidth: isDesktop ? "94%" : isMobile ? "96%" : "90%",
                fontWeight: 700,
                textAlign: "center",
                /*  lineHeight: isDesktop ? "1.8rem" : "",
                fontSize: isDesktop ? "1.8rem" : "1.3rem !important", */
              }}
            >
              IT-05 DNB | Memoria descriptiva | Cálculo hidráulico | Prueba de bomba y del sistema
            </Typography>
            {/*  <Grid
              container
              sx={{
                maxWidth: isDesktop ? "94%" : isMobile ? "98%" : "90%",
                minHeight: "40%",
              }}
              justifyContent="space-between"
              column={12}
              alignItems="flex-start"
            >
              <Grid item={6} alignItems="center">
                <Box
                  sx={{
                    display: "flex",
                    border: "solid 1px #fafafa",
                    padding: ".5rem",
                    borderRadius: "4px",
                    justifyContent: "center",
                    backgroundColor: "rgba(0,0,0,0.3)",
                    alignItems: "center",
                  }}
                >
                  <TaskIcon color="white" fontSize="large" />{" "}
                  <Typography variant="body-1">IT-05 DNB</Typography>
                </Box>
              </Grid>

              <Grid item={6} alignItems="center">
                <Box
                  sx={{
                    display: "flex",
                    border: "solid 1px #fafafa",
                    padding: ".5rem",
                    borderRadius: "4px",
                    justifyContent: "center",
                    backgroundColor: "rgba(0,0,0,0.3)",
                    alignItems: "center",
                  }}
                >
                  <DescriptionIcon color="white" fontSize="large" />{" "}
                  <Typography variant="body-1">Memoria descriptiva</Typography>
                </Box>
              </Grid>

              <Grid
                container
                sx={{
                  maxWidth: isDesktop ? "99%" : isMobile ? "98%" : "90%",
                  minHeight: "40%",
                }}
                justifyContent="space-between"
                column={12}
                alignItems="flex-end"
              >
                <Grid item={6} alignItems="center">
                  <Box
                    sx={{
                      display: "flex",
                      border: "solid 1px #fafafa",
                      padding: ".5rem",
                      borderRadius: "4px",
                      justifyContent: "center",
                      backgroundColor: "rgba(0,0,0,0.3)",
                      alignItems: "center",
                    }}
                  >
                    <PsychologyIcon color="white" fontSize="large" />{" "}
                    <Typography variant="body-1">Cálculo hidráulico</Typography>
                  </Box>
                </Grid>

                <Grid
                  item={6}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      display: "flex",
                      border: "solid 1px #fafafa",
                      padding: ".5rem",
                      borderRadius: "4px",
                      justifyContent: "flex-end",
                      backgroundColor: "rgba(0,0,0,0.3)",
                      alignItems: "center",
                    }}
                  >
                    <PublishedWithChangesIcon color="white" fontSize="large" />{" "}
                    <Typography
                      sx={{ maxWidth: "150px", textAlign: "start" }}
                      variant="body-1"
                    >
                      Prueba de bomba y del sistema
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid> */}

            {!isDesktop && (
              <Stack
                sx={{ width: "96%", margin: "0 auto" }}
                direction="row"
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  color="success"
                  sx={{
                    mt: 1,
                    fontWeight: "bold",
                    zIndex: 10,
                    width: "20rem",
                  }}
                  href={"/hidraulica#contacto"}
                >
                  quiero asesoramiento
                </Button>
              </Stack>
            )}
          </Box>
          {isDesktop && (
            <Box sx={{ width: "30%" }}>
              {" "}
              <FormularioHidraulica id="hidraulica" />{" "}
            </Box>
          )}
        </Stack>
        {/* Overlay negro */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1,
          }}
        />
      </Box>
      {!isDesktop && (
        <ContactForm
          placeholder="escriba su mensaje"
          id="hidraulica"
        />
      )}

      <Box py="2rem" sx={{ bgcolor: "#fafafa" }}>
        <Container>
          <Box my="2rem">
            <Typography variant="h5" textTransform="uppercase" gutterBottom>
              Sistemas hidráulicos contra incendios
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
            >
              En Conecta-Tech diseñamos y ejecutamos soluciones integrales de
              protección contra incendios, evaluando cada proyecto de forma
              individual y en cumplimiento con el Decreto 372/023, la Ley 18.896
              y los Instructivos Técnicos de Bomberos.
            </Typography>
          </Box>
          <Stack alignItems="center">
            <Box my="2rem">
              <Typography variant="h5" textTransform="uppercase" gutterBottom>
                Servicios principales
              </Typography>
            </Box>
            <Stack alignItems="flex-start">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                {" "}
                <RadioButtonCheckedIcon sx={{ marginRight: "1.5rem" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
                >
                  Diseño, planificación e instalación de sistemas hidráulicos.
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                {" "}
                <RadioButtonCheckedIcon sx={{ marginRight: "1.5rem" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
                >
                  {" "}
                  Reservas de agua, estaciones de bombeo y redes de
                  distribución.
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                {" "}
                <RadioButtonCheckedIcon sx={{ marginRight: "1.5rem" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
                >
                  {" "}
                  Cañerías, banco de bombas, tableros de automatismo, tanques y
                  bocas de incendio.{" "}
                </Typography>{" "}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                {" "}
                <RadioButtonCheckedIcon sx={{ marginRight: "1.5rem" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
                >
                  Reparación, mantenimiento y actualización de sistemas según
                  normativa DNB.{" "}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                {" "}
                <RadioButtonCheckedIcon sx={{ marginRight: "1.5rem" }} />
                <Typography
                  variant="body1"
                  sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
                >
                  Pruebas de funcionamiento, presión y seguridad conforme al
                  IT-05.{" "}
                </Typography>
              </Box>
            </Stack>
            <Typography
              variant="body1"
              sx={{
                fontSize: isMobile ? "1.2rem" : "1.43rem",
                marginTop: "1rem",
              }}
            >
              Con nuestro equipo técnico garantizamos un sistema seguro,
              eficiente y en condiciones inmediatas de uso.
            </Typography>
          </Stack>
        </Container>
      </Box>

      {/* Beneficios */}
      {/*   <Box sx={{ bgcolor: "#f9f9f9" }}>
        <Container sx={{ py: 6 }}>
          <Typography
            variant="h4"
            mb={isMobile ? "2rem" : "4rem"}
            textTransform="uppercase"
            gutterBottom
          >
            Reseñas
          </Typography>
          <Grid container spacing={4}>
            {[
              {
                label: "Experiencia Especializada",
                icon: <VerifiedIcon fontSize="large" color="success" />,
              },
              {
                label: "Cumplimiento Normativo",
                icon: <GppGoodIcon color="success" fontSize="large" />,
              },
              {
                label: "Atención Personalizada",
                icon: <PsychologyIcon color="success" fontSize="large" />,
              },
            ].map((benefit, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Box textAlign="center">
                  {benefit.icon}
                  <Typography
                    variant="h6"
                    textTransform="uppercase"
                    sx={{ mt: 1 }}
                  >
                    {benefit.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box> */}

     {/*  <Box>
        <Reviews endpoint={ENDPOINT} limit={6} placeIdForWriteLink={PLACE_ID} />
      </Box> */}
      {/* Formulario de Contacto */}
      <Divider />
      <WhatsAppButton
        id="btn-whatsapp-hidraulica"
        srOnly="Whatsapp hidraulica"
        message="Necesito asesoramiento para una instalación hidráulica"
      />
      {/* <ContactForm id="bomberos" /> */}
    </Box>
  );
};

export default Hidraulica;
